<template >
    <div class="page">
        <div class="content">
            <div class="title td-fcc">
                <span>联系客服</span>
            </div>
            <div class="tips" v-if="type == 1">请联系客服人员解锁课程，我们将竭诚为您服务</div>
            <div class="tips" v-else>使用过程中有任何问题可以联系客服热线，我们将竭诚为您服务</div>
            <div class="phone td-fcc">
                <img :src="Images.icon_user_white" />
                <span>咨询顾问电话：</span>
                <span v-if="service&&service.customer_service">{{service.customer_service.name}} {{service.customer_service.mobile}}</span>
                <span v-else>******</span>
            </div>
        </div>
        <div class="footer">
            <img :src="Images.img_about_us" >
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    /** 数据区 */
    data() {
        return {
            type: 0,
        };
    },
    /** 加载前 */
    created () {
        this.type = this.$route.query.type || 0
    },
    /** 计算 */
    computed: {
        ...mapGetters(["service"]),
    },
    /** 方法 */
    methods: {
        
    },
};
</script>

<style lang="less" scoped>
.page{
    background-color: #fff;
    min-height: 100vh;
    background-image: url('../../assets/img/img_bg_about_us.png');
    background-size: 100% auto;
    overflow: hidden;
}
.content{
    margin: 40px 15px 0;
    background-color: #fff;
    border-radius: 4px 4px 0 0;
    padding: 80px 10px 50px;
    position: relative;
    .title{
        position: absolute;
        top: -13px;
        left: 50%;
        transform: translateX(-50%);
        width: 208px;
        height: 48px;
        background-image: url('../../assets/img/img_bg_aboutus_title.png');
        background-size: 100% 100%;
        span{
            font-size: 18px;
            color: #ffffff;
            font-weight: 500;
            background-image: url('../../assets/img/img_bg_aboutus_title_text.png');
            background-size: 100% 100%;
            padding: 0 20px;
        }
    }
    .tips{
        font-size: 14px;
        text-align: center;
        color: #333333;
    }
    .phone{
        margin-top: 50px;
        height: 50px;
        background-image: url('../../assets/img/img_bg_aboutus_contact.jpg');
        background-size: 100% 100%;
        span{
            font-size: 13px;
            color: #ffffff;
            font-weight: 600;
        }
        img{
            width: 16px;
            height: 16px;
            display: block;
            object-fit: contain;
            margin-right: 5px;
        }
    }
}
.footer{
    margin: 0 15px;
    img{
        width: 100%;
    }
}
</style>